import { createContext, useContext, type ReactNode } from 'react';
import { useAppSelector } from '../../../../../hooks/redux';
import {
  selectScheduleColumnWidth,
  selectScheduleItemScaleMultiplier,
} from '../../../../../features/schedule/scheduleSelectors';

export type ScheduleZoomTier = 'normal' | 'compact' | 'super-compact';

export type ScheduleZoomContextValue = {
  scale: number;
  columnWidth: number;
  isGesturing: boolean;
};

const ScheduleZoomContext = createContext<ScheduleZoomContextValue | null>(null);

export function ScheduleZoomProvider({
  value,
  children,
}: {
  value: ScheduleZoomContextValue;
  children: ReactNode;
}) {
  return <ScheduleZoomContext.Provider value={value}>{children}</ScheduleZoomContext.Provider>;
}

export function useScheduleZoom(): ScheduleZoomContextValue {
  const context = useContext(ScheduleZoomContext);
  const reduxScale = useAppSelector(selectScheduleItemScaleMultiplier);
  const reduxColumnWidth = useAppSelector(selectScheduleColumnWidth);
  if (context) return context;
  return { scale: reduxScale, columnWidth: reduxColumnWidth, isGesturing: false };
}

export function getScheduleZoomTier(scale: number, courtWidth: number): ScheduleZoomTier {
  if ((scale <= 1 || courtWidth <= 60) && (scale <= 2 || courtWidth <= 40)) {
    return 'super-compact';
  }
  if (scale <= 3 || courtWidth <= 80) {
    return 'compact';
  }
  return 'normal';
}
